import {
  IMemberFileResponse,
  IMemberFileSummaryResponse,
  IMemberPublicFileResponse
} from "@wingspanhq/files/dist/lib/interfaces";
import { ListRequestQuery } from "../utils/serviceHelper";
import { WSService } from "../utils/WSService";

const service = new WSService("/files", [
  {
    regex: /File Already Exist/,
    message: "Sorry! A file with that name already exists."
  },
  {
    regex: /must be less than or equal to 100mb in size/,
    message: "Sorry! That file is too large. Max size is 100MB."
  },
  {
    regex: /Invalid file/,
    message: "Sorry! Cannot upload executable files."
  }
]);

// Private files

export interface PrivateFilesAPIFilter {
  hidden?: boolean;
  tags?: {
    in: string[];
  };
}

export type PrivateFilesQuery = ListRequestQuery<PrivateFilesAPIFilter>;

const getPrivateFiles = async (
  query?: PrivateFilesQuery
): Promise<IMemberFileResponse[]> => {
  const { data } = await service.get("/member/private", {
    params: query
  });
  return data;
};

const createPrivateFile = async (
  formData: FormData,
  hidden?: boolean,
  tags?: string[],
  viewerIds?: string[]
): Promise<IMemberFileResponse[]> => {
  const { data } = await service.post("/member/private/upload", formData, {
    params: {
      hidden,
      tags: tags?.join(","),
      viewerIds: viewerIds?.join(",")
    }
  });
  return data;
};

const getPrivateFile = async (id: string): Promise<IMemberFileResponse> => {
  const { data } = await service.get(`/member/private/${id}`);
  return data;
};

const downloadPrivateFile = async (id: string): Promise<ArrayBuffer> => {
  const { data } = await service.get(`/member/private/${id}/download`, {
    responseType: "arraybuffer"
  });
  return data;
};

const deletePrivateFile = async (id: string): Promise<void> => {
  await service.delete(`/member/private/${id}`);
};

// Public files
const getPublicFiles = async (): Promise<IMemberPublicFileResponse[]> => {
  const { data } = await service.get("/member/public");
  return data;
};

const getPublicFile = async (
  id: string
): Promise<IMemberPublicFileResponse> => {
  const { data } = await service.get(`/member/public/${id}`);
  return data;
};

const getPublicFileSummary = async (
  id: string
): Promise<IMemberFileSummaryResponse> => {
  const { data } = await service.get(`/member/public/${id}/summary`);
  return data;
};

const downloadPublicFile = async (id: string): Promise<any> => {
  const { data } = await service.get(`/member/public/${id}/download`, {
    responseType: "arraybuffer"
  });
  return data;
};

const deletePublicFile = async (id: string): Promise<void> => {
  await service.delete(`/member/public/${id}`);
};

export const filesService = {
  member: {
    public: {
      list: getPublicFiles,
      get: getPublicFile,
      download: downloadPublicFile,
      summary: getPublicFileSummary,
      delete: deletePublicFile
    },
    private: {
      list: getPrivateFiles,
      create: createPrivateFile,
      get: getPrivateFile,
      download: downloadPrivateFile,
      delete: deletePrivateFile
    }
  }
};
